export default {
    namespaced: true,
    state: {
        buildingTrashed: [],
        zoneTrashed: [],
        buildingCounters: [],
        bread_active: null,
        bread_list: null,
        componentKey: 0,
    },
    getters: {},
    mutations: {
        SET_DATA: function (state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        buildingsTrashed(state) {
            axios.get('/api/v2/trash/buildingsTrashed')
                .then(function (response) {
                    state.commit('SET_DATA', {
                        name: 'buildingTrashed',
                        data: response.data.mappingList
                    });

                    state.commit('SET_DATA', {
                        name: 'zoneTrashed',
                        data: response.data.zoneList
                    });


                }).catch(error => {
                    if (error.response.status === 401) {
                        window.location.href = '/login?msg=session_expired';
                    }

                });
        },

        buildigsRestore(state, payload) {
            axios.get('/api/v2/trash/buildingsRestore/' + payload.idToRestore)
                .then(function (response) {


                    state.dispatch('buildingsTrashed');

                })
        },

        zoneRestore(state, payload) {
            axios.get('/api/v2/trash/zoneRestore/' + payload.idToRestore)
                .then(function (response) {
                    state.dispatch('buildingsTrashed');
                })
        }
    }
}
